import { FunctionComponent } from 'react'

import styled, { css } from 'styled-components'

import ClickableContainer from '../Common/ClickableContainer'
import ImageWrapper from '../Common/ImageWrapper'
import { SingleAuthorProps } from '../types'
import SingleAuthor from './SingleAuthor'

const Wrapper = styled.div`
  display: flex;
  align-items: center;
`

const StyledImageWrapper = styled(ImageWrapper)`
  ${({
    theme: {
      spacing: { spacing8 },
    },
  }) => css`
    margin-right: ${spacing8};
  `}
`

const SingleAuthorWrapper: FunctionComponent<SingleAuthorProps> = ({
  image,
  link,
  ...props
}) => (
  <ClickableContainer link={link}>
    <Wrapper>
      {!!image && <StyledImageWrapper>{image}</StyledImageWrapper>}
      <SingleAuthor link={link} {...props} />
    </Wrapper>
  </ClickableContainer>
)

export default SingleAuthorWrapper
